import { MDBBtn, MDBCol, MDBContainer, MDBRow, MDBTypography } from 'mdbreact';
import React from 'react';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Header.scss";
import Back from "./../../../assets/images/back/back-blog.png";

const Header = (props: HeaderProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <section className="header">
        <MDBContainer>
            <MDBRow middle center>
                <MDBCol md="12" className="brand-image">
                    <img src={Back} alt="Back" />
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    </section>
};

interface HeaderProps { }
export default Header;